export default {
    /* GET_PLATE_ORDERS
    ---------------------------------------------------------------
    */
    GET_PLATE_ORDERS_REQUEST: state => {
        state.plateOrdersLoading = true
    },
    GET_PLATE_ORDERS_SUCCESS: (state, data) => {
        state.plateOrders = data.results
        state.plateOrdersLoading = false
    },
    GET_PLATE_ORDERS_FAILURE: state => {
        state.plateOrdersLoading = false
    },
    SET_PLATE_ORDERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PLATE_ORDERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}